import _, { update } from "lodash";
import { InputSelector } from "./InputSelector";
import { IBaseFormProps } from "../interfaces";
import {
  Dropdown,
  FieldName,
  IBaseInputProps,
  IDropdownOption,
} from "./Inputs";
import { useEffect, useState } from "react";
import apiAgent from "../../api/apiAgent";
import { Spinner } from "../Loader";
import Select from "react-select";
import { checkFieldName } from "../../utils";

const MomentDropdown = (props: IBaseInputProps) => {
  const { name, value, className, onChange } = props;
  const [options, setOptions] = useState<IDropdownOption[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const parsedValue = value?.map((name: string) => name.replaceAll('"', ""));

  useEffect(() => {
    fetchOptions();
  }, []);

  const fetchOptions = async () => {
    try {
      setLoading(true);
      const response = await apiAgent.SingleItem.get(props.name);
      if (response.status === 200) {
        const data = JSON.parse(response.data.data);
        const parseOptions =
          data?.values?.map((item: string) => {
            return {
              label: item,
              value: item,
            };
          }) || [];
        setOptions(parseOptions);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const dropdownValue =
    parsedValue?.reduce((arr: string[], item: string) => {
      const findFromOptions = options.find((o) => o.value === item);
      if (!findFromOptions) return arr;
      return [...arr, findFromOptions];
    }, []) || [];

  return loading ? (
    <Spinner />
  ) : (
    <Select
      name={name}
      options={options}
      value={dropdownValue}
      className={className}
      onChange={(e) => {
        const parseOptions = e.map((item) => item.value);
        onChange(parseOptions);
      }}
      required={props.required}
      isDisabled={props.disabled}
      isMulti
    />
  );
};

/**
 *
 * @param schema loaded schema
 * @param modelName name of model
 * @param itemData itemData state
 * @param setItemData setItemData state
 * @returns
 */
const MomentForm = ({
  schema,
  modelName,
  itemData,
  setItemData,
  customModel,
  onSubmit,
}: IBaseFormProps): JSX.Element => {
  const updateItemData = (keyname: string, value: any) => {
    if (_.has(itemData, keyname))
      setItemData({
        ...itemData,
        [keyname]: value,
      });
  };

  return (
    <form onSubmit={onSubmit} id="base-form">
      <div className="flex flex-col gap-4">
        {schema.map((item, index) => {
          if (item.name === "topics" || item.name === "place") {
            const [name, hint] = checkFieldName(item.name, "moment");
            return (
              <div className={"mb-2 space-y-1"} key={index}>
                <FieldName name={name} hint={hint} />
                <MomentDropdown
                  value={itemData[item.name]}
                  name={item.name}
                  type="dropdown"
                  onChange={(e) => updateItemData(item.name, e)}
                />
              </div>
            );
          }
          return (
            <InputSelector
              value={itemData[item.name]}
              key={index}
              onChange={(e) => {
                updateItemData(
                  item.name,
                  item.type === "number"
                    ? e.target.valueAsNumber
                    : item.type === "bool"
                    ? e.target.checked
                    : e.target.value
                );
              }}
              modelname={modelName}
              customModel={customModel}
              {...item}
            />
          );
        })}
      </div>
    </form>
  );
};

export default MomentForm;
